export const navbarStyle = {
  background: "#0F0730",
};

export const linkAvtiveStyle = {
  color: "#D8D8D8",
  textDecoration: "none",
  fontWeight: "500",
  fontSize: "14px",
};

export const iconStyle = {
  color: "#1D4CF2",
  border: "1px solid rgba(29, 76, 242, 0.5)",
  height: "40px",
  width: "40px",
  borderRadius: "10px",
};

export const languageStyle = {
  color: "#F4F4F4",
  border: "1px solid rgba(244, 244, 244, 0.15)",
  borderRadius: "10px",
  width: "40px",
  height: "40px",
};
